"use client"
import { useEffect, useState } from "react"
import { SessionProvider } from "next-auth/react"
import useMutation from "@src/hooks/use-mutation"
import { useSession } from "next-auth/react"
import { useDispatch } from "react-redux"
import { setUser } from "@src/store/slices/userSlice"
import { syncCartItemCount } from "@src/utils/cart-count"
import { LOCAL_KEYS, LocalStorage } from "@src/utils/storages"


const FistTimeLoadAuth = ({ children }) => {
  const { data: session, status } = useSession()
  const dispatch = useDispatch()
  const { mutation } = useMutation()

  const [isInit, setIsInit] = useState(false)

  useEffect(() => {
    if (!isInit) {
      if (status === "authenticated") {
        if ((session as any)?.user) {
          dispatch(setUser((session as any).user))
          syncCartItemCount((session as any).user?.total_cart_items ?? 0)
        }
        setIsInit(true)
      } else if (status === "unauthenticated") {
        const currentDeviceSession = LocalStorage.get(LOCAL_KEYS.DEVICE_SESSION)
        if (currentDeviceSession) {
          mutation({
            method: "GET",
            url: "/auth/profile",
            config: {
              deviceAuthenticated: true
            },
            onSuccess: res => {
              syncCartItemCount(res?.total_cart_items ?? 0)
            }
          })
          setIsInit(true)
          return
        }
        mutation({
          method: "POST",
          url: "/login-with-device",
          params: {
            device_token: currentDeviceSession?.device_token || "",
          },
          onSuccess: res => {
            if (res) {
              LocalStorage.set(LOCAL_KEYS.DEVICE_SESSION, {
                access_token: res?.access_token,
                auth_type: res?.user?.auth_type || "",
                device_token: res?.user?.device_token || "",
              })
              syncCartItemCount(res?.user?.total_cart_items ?? 0)
            }
          },
        })
        setIsInit(true)
      }
    }
   
  }, [status, isInit, session, dispatch])

  return children
}

export function AuthProvider({ children }) {
  return (
    <SessionProvider basePath="/server/auth">
      <FistTimeLoadAuth>{children}</FistTimeLoadAuth>
    </SessionProvider>
  )
}
